import { createRouter } from '@tanstack/react-router'
import { routeTree } from '@gen/routeTree.gen'

export const router = createRouter({
  routeTree,
  context: {
    // Will be set below.
    queryClient: undefined!,
  },
})
